import { GlobalContext } from 'Context/GlobalContext/AppContext';
import { ReactComponent as AlertSvg } from 'assets/alert.svg';
import { useContext } from 'react';
import Button from '../../atoms/Button';
import BaseModal from 'components/molecules/BaseModal';
import './styles.scss';

const emptyState = {
  isVisible: false,
  title: '',
  text: '',
  emphasis: '',
  callback: null,
};

const ValidationModal = () => {
  const { validationModal, setValidationModal, setResponseMsg, setLoading } = useContext(GlobalContext);

  function handleConfirm() {
    validationModal
      .callback() //function passed by Component that need confirm before execute
      .catch((error) => {
        console.error(error);
        setResponseMsg({ isVisible: true, error: true, msg: error.message });
      })
      .finally(() => {
        setLoading(false);
        setValidationModal(emptyState);
      });
  }

  return (
    <BaseModal isVisible={validationModal.isVisible} handleClose={() => setValidationModal(emptyState)}>
      <h2 className="validationModal__title">{validationModal.title}</h2>
      <AlertSvg className="validationModal__alertIcon" />
      <div className="validationModal__detail">
        <p className="validationModal__text">{validationModal.text}</p>
        <p className="validationModal__status">{validationModal.emphasis}</p>
      </div>
      <div className="validationModal__buttons">
        <Button visual="not" onClick={() => setValidationModal(emptyState)}>
          Não
        </Button>
        <Button visual="confirm" onClick={handleConfirm}>
          Sim
        </Button>
      </div>
    </BaseModal>
  );
};

export default ValidationModal;
